
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {FetchOptions} from 'ofetch';
import type {
  OrganizationOptionScimUpdateRequest,
  ScimAttributeMappingResource,
  ScimUsageStatResource,
  UpdateScimAttributeMappingRequest,
} from '../models';
import {
    OrganizationOptionScimUpdateRequestFromJSON,
    OrganizationOptionScimUpdateRequestToJSON,
    ScimAttributeMappingResourceFromJSON,
    ScimAttributeMappingResourceToJSON,
    ScimUsageStatResourceFromJSON,
    ScimUsageStatResourceToJSON,
    UpdateScimAttributeMappingRequestFromJSON,
    UpdateScimAttributeMappingRequestToJSON,
} from '../models';

export interface GetAttributeMappingsRequest {
    organizationId: string;
}

export interface GetScimUsageStatsRequest {
    organizationId: string;
}

export interface ToggleScimOptionRequest {
    organizationId: string;
    organizationOptionScimUpdateRequest: OrganizationOptionScimUpdateRequest;
}

export interface UpdateAttributeMappingsRequest {
    organizationId: string;
    updateScimAttributeMappingRequest: UpdateScimAttributeMappingRequest;
}

/**
 * 
 */
export class OrganizationScimSettingsAdminApi extends runtime.BaseAPI {

    /**
     * Retrieve the given organization scim attribute mappings
          */
    async getAttributeMappingsRaw(requestParameters: GetAttributeMappingsRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<ScimAttributeMappingResource>> {
        if (requestParameters['organizationId'] == null) {
            throw new runtime.RequiredError(
                'organizationId',
                'Required parameter "organizationId" was null or undefined when calling getAttributeMappings().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<ScimAttributeMappingResource>({
            path: `/client-settings/api/organizations/{organizationId}/scim/attribute-mappings`.replace(`{${"organizationId"}}`, encodeURIComponent(String(requestParameters['organizationId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=ScimAttributeMappingResourceFromJSON(response._data); }
        return response;
    }

    /**
     * Retrieve the given organization scim attribute mappings
          */
    async getAttributeMappings(requestParameters: GetAttributeMappingsRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<ScimAttributeMappingResource> {
        const response = await this.getAttributeMappingsRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
     * Retrieve statistics about organization scim usage
          */
    async getScimUsageStatsRaw(requestParameters: GetScimUsageStatsRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<ScimUsageStatResource>> {
        if (requestParameters['organizationId'] == null) {
            throw new runtime.RequiredError(
                'organizationId',
                'Required parameter "organizationId" was null or undefined when calling getScimUsageStats().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<ScimUsageStatResource>({
            path: `/client-settings/api/organizations/{organizationId}/scim/stats`.replace(`{${"organizationId"}}`, encodeURIComponent(String(requestParameters['organizationId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=ScimUsageStatResourceFromJSON(response._data); }
        return response;
    }

    /**
     * Retrieve statistics about organization scim usage
          */
    async getScimUsageStats(requestParameters: GetScimUsageStatsRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<ScimUsageStatResource> {
        const response = await this.getScimUsageStatsRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
     * Toggle SCIM option activation
          */
    async toggleScimOptionRaw(requestParameters: ToggleScimOptionRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        if (requestParameters['organizationId'] == null) {
            throw new runtime.RequiredError(
                'organizationId',
                'Required parameter "organizationId" was null or undefined when calling toggleScimOption().'
            );
        }

        if (requestParameters['organizationOptionScimUpdateRequest'] == null) {
            throw new runtime.RequiredError(
                'organizationOptionScimUpdateRequest',
                'Required parameter "organizationOptionScimUpdateRequest" was null or undefined when calling toggleScimOption().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<void>({
            path: `/client-settings/api/organizations/{organizationId}/settings/scim/toggle`.replace(`{${"organizationId"}}`, encodeURIComponent(String(requestParameters['organizationId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: OrganizationOptionScimUpdateRequestToJSON(requestParameters['organizationOptionScimUpdateRequest']),
        }, initOverrides);

        return response;
    }

    /**
     * Toggle SCIM option activation
          */
    async toggleScimOption(requestParameters: ToggleScimOptionRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.toggleScimOptionRaw(requestParameters, initOverrides);
    }

    /**
     * Update the given organzation scim attribute mappings
          */
    async updateAttributeMappingsRaw(requestParameters: UpdateAttributeMappingsRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        if (requestParameters['organizationId'] == null) {
            throw new runtime.RequiredError(
                'organizationId',
                'Required parameter "organizationId" was null or undefined when calling updateAttributeMappings().'
            );
        }

        if (requestParameters['updateScimAttributeMappingRequest'] == null) {
            throw new runtime.RequiredError(
                'updateScimAttributeMappingRequest',
                'Required parameter "updateScimAttributeMappingRequest" was null or undefined when calling updateAttributeMappings().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<void>({
            path: `/client-settings/api/organizations/{organizationId}/scim/stats`.replace(`{${"organizationId"}}`, encodeURIComponent(String(requestParameters['organizationId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateScimAttributeMappingRequestToJSON(requestParameters['updateScimAttributeMappingRequest']),
        }, initOverrides);

        return response;
    }

    /**
     * Update the given organzation scim attribute mappings
          */
    async updateAttributeMappings(requestParameters: UpdateAttributeMappingsRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.updateAttributeMappingsRaw(requestParameters, initOverrides);
    }

}
